import { createUserManager } from 'redux-oidc'
import { UserManagerConfig } from './config'

const userManager = createUserManager(UserManagerConfig)

export default userManager



// WEBPACK FOOTER //
// ./src/userManager.js